import { useCallback } from 'react';

import { TSetRoutePoints } from '../types/setRoutePoints';
import { TRoutePoint } from '../types/routePoints';
import getRoutePoint from '../utils/getRoutePoint';

const useAddRoutePoint = (setRoutePoints: TSetRoutePoints) => {
  const onAddRoutePoint = useCallback(() => {
    setRoutePoints((prevPoints) => {
      const points = [...prevPoints];
      const lastPoint = points.pop() as TRoutePoint;
      return [...points, getRoutePoint(), lastPoint];
    });
  }, [setRoutePoints]);

  return onAddRoutePoint;
};

export default useAddRoutePoint;
